export default __webpack_public_path__ + "static/media/notfoundimage.4ec42651.svg";